const AmericanSamoaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_110730)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M29.7028 2.50875C26.8291 0.91125 23.5211 0 20 0C8.95516 0 0.00140625 8.95297 0 19.9977L13.913 13.0435L29.7028 2.50875Z"
        fill="#0052B4"
      />
      <path
        d="M0 20.002C0.00140625 31.0466 8.95516 39.9996 20 39.9996C23.5211 39.9996 26.8291 39.0885 29.7028 37.4909L13.913 26.9561L0 20.002Z"
        fill="#0052B4"
      />
      <path
        d="M31.3695 3.5452C30.8323 3.1734 30.2757 2.82762 29.7021 2.50879L0 19.9974V19.9997C0 19.9997 0 20.0014 0 20.0021L29.7022 37.4906C30.2758 37.1717 30.8323 36.826 31.3696 36.4542L3.42359 19.9997L31.3695 3.5452Z"
        fill="#D80027"
      />
      <path
        d="M34.7822 19.2543H32.3998C33.0193 18.5105 32.9811 17.404 32.2832 16.7063C33.0224 15.9671 33.0224 14.7686 32.2832 14.0293L32.2387 14.074C32.9778 13.3349 33.0224 12.0917 32.2832 11.3525L21.5757 22.06C22.3149 22.7993 23.4924 22.7905 24.2315 22.0513L24.4376 21.8629L29.5648 21.3968V23.602H31.304V21.2387L33.9126 21.0016L34.7822 19.2543Z"
        fill="#A2001D"
      />
      <path
        d="M21.7398 24.3475L20 23.478L21.7398 22.6084H33.0441V24.3475H21.7398Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110730">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AmericanSamoaSvg;
